import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-2fea51b8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "comments"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "name"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "bottom"
};
const _hoisted_7 = {
  class: "left"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "right"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.songComment !== null && $props.musicList !== null ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, "评论(" + _toDisplayString($props.songComment.data.total) + ")", 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
    src: $props.musicList.al.picUrl,
    alt: ""
  }, null, 8, _hoisted_5), _createElementVNode("span", null, _toDisplayString($props.musicList.name), 1), _createElementVNode("i", null, _toDisplayString($props.musicList.ar[0].name), 1)])]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.songComment.data.comments, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "list",
      key: item
    }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
      src: item.user.avatarUrl,
      alt: ""
    }, null, 8, _hoisted_8)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("p", null, _toDisplayString(item.user.nickname), 1), _createElementVNode("p", null, _toDisplayString(item.timeStr), 1), _createElementVNode("p", null, _toDisplayString(item.content), 1)])]);
  }), 128))])])) : _createCommentVNode("", true);
}